import React, {useEffect, useState} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {Box, Snackbar} from '@mui/material';
import contentLabStore, {
  contentLabActions,
} from '@contentlab/stores/contentLabStore';
import MainErrorDisplay from './MainErrorDisplay';
import SingleAlertDisplay from './SingleAlertDisplay';
import SingleErrorDisplay from './SingleErrorDisplay';

function ErrorToast() {
  const {errors, alerts} = contentLabStore(
    useShallow((state) => ({
      errors: state.errors,
      alerts: state.alerts,
    }))
  );
  const [isOpen, setIsOpen] = useState(true);
  useEffect(() => {
    setIsOpen(true);
  }, [errors]);
  return (
    <Snackbar
      open={errors.length > 0 || alerts.length > 0}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      sx={{
        width: 'fit-content',
        margin: '0 auto',
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          alignItems: 'center',
        }}
      >
        {errors.length > 0 && (
          <MainErrorDisplay
            errorAmount={errors.length + alerts.length}
            onClear={() => {
              setIsOpen(false);
              contentLabActions.clearErrors();
              contentLabActions.clearAlerts();
            }}
            isOpen={isOpen}
            setIsOpen={() => setIsOpen(!isOpen)}
          />
        )}
        {isOpen &&
          errors.map((error) => (
            <SingleErrorDisplay
              key={error.id}
              errorTitle={error.title}
              errorDescription={error.description}
              errorKind={error.kind}
              onClose={() => {
                contentLabActions.removeError(error.id);
              }}
            />
          ))}
        {alerts.map((alert) => (
          <SingleAlertDisplay
            key={alert.id}
            errorTitle={alert.title}
            errorDescription={alert.description}
            onClose={() => {
              contentLabActions.removeAlert(alert.id);
            }}
          />
        ))}
      </Box>
    </Snackbar>
  );
}

export default ErrorToast;
